export default __webpack_public_path__ + "static/media/EGL.233d93de.png";